export default __webpack_public_path__ + "static/decorist-8-e-38861840d2af6c39b9e6f0a4b199b3d0.webp";